"use strict";

exports.__esModule = true;
exports.TranslateYTimeline = exports.TranslateXTimeline = exports.TranslateTimeline = exports.TransformConstraintTimeline = exports.Timeline = exports.ShearYTimeline = exports.ShearXTimeline = exports.ShearTimeline = exports.ScaleYTimeline = exports.ScaleXTimeline = exports.ScaleTimeline = exports.RotateTimeline = exports.RGBTimeline = exports.RGBATimeline = exports.RGBA2Timeline = exports.RGB2Timeline = exports.PathConstraintSpacingTimeline = exports.PathConstraintPositionTimeline = exports.PathConstraintMixTimeline = exports.MixDirection = exports.MixBlend = exports.IkConstraintTimeline = exports.EventTimeline = exports.DrawOrderTimeline = exports.DeformTimeline = exports.CurveTimeline2 = exports.CurveTimeline1 = exports.CurveTimeline = exports.AttachmentTimeline = exports.Animation = exports.AlphaTimeline = void 0;

var _Attachment = require("./attachments/Attachment");

var _Utils = require("./Utils");

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/** A simple container for a list of timelines and a name. */
var Animation = /*#__PURE__*/function () {
  function Animation(name, timelines, duration) {
    this.timelines = null;
    this.timelineIds = null;
    if (!name) throw new Error("name cannot be null.");
    this.name = name;
    this.setTimelines(timelines);
    this.duration = duration;
  }

  var _proto = Animation.prototype;

  _proto.setTimelines = function setTimelines(timelines) {
    if (!timelines) throw new Error("timelines cannot be null.");
    this.timelines = timelines;
    this.timelineIds = new _Utils.StringSet();

    for (var i = 0; i < timelines.length; i++) {
      this.timelineIds.addAll(timelines[i].getPropertyIds());
    }
  };

  _proto.hasTimeline = function hasTimeline(ids) {
    for (var i = 0; i < ids.length; i++) {
      if (this.timelineIds.contains(ids[i])) return true;
    }

    return false;
  }
  /** Applies all the animation's timelines to the specified skeleton.
   *
   * See Timeline {@link Timeline#apply(Skeleton, float, float, Array, float, MixBlend, MixDirection)}.
   * @param loop If true, the animation repeats after {@link #getDuration()}.
   * @param events May be null to ignore fired events. */
  ;

  _proto.apply = function apply(skeleton, lastTime, time, loop, events, alpha, blend, direction) {
    if (!skeleton) throw new Error("skeleton cannot be null.");

    if (loop && this.duration != 0) {
      time %= this.duration;
      if (lastTime > 0) lastTime %= this.duration;
    }

    var timelines = this.timelines;

    for (var i = 0, n = timelines.length; i < n; i++) {
      timelines[i].apply(skeleton, lastTime, time, events, alpha, blend, direction);
    }
  };

  return Animation;
}();
/** Controls how a timeline value is mixed with the setup pose value or current pose value when a timeline's `alpha`
 * < 1.
 *
 * See Timeline {@link Timeline#apply(Skeleton, float, float, Array, float, MixBlend, MixDirection)}. */


exports.Animation = Animation;
var MixBlend;
exports.MixBlend = MixBlend;

(function (MixBlend) {
  /** Transitions from the setup value to the timeline value (the current value is not used). Before the first key, the setup
   * value is set. */
  MixBlend[MixBlend["setup"] = 0] = "setup";
  /** Transitions from the current value to the timeline value. Before the first key, transitions from the current value to
   * the setup value. Timelines which perform instant transitions, such as {@link DrawOrderTimeline} or
   * {@link AttachmentTimeline}, use the setup value before the first key.
   *
   * `first` is intended for the first animations applied, not for animations layered on top of those. */

  MixBlend[MixBlend["first"] = 1] = "first";
  /** Transitions from the current value to the timeline value. No change is made before the first key (the current value is
   * kept until the first key).
   *
   * `replace` is intended for animations layered on top of others, not for the first animations applied. */

  MixBlend[MixBlend["replace"] = 2] = "replace";
  /** Transitions from the current value to the current value plus the timeline value. No change is made before the first key
   * (the current value is kept until the first key).
   *
   * `add` is intended for animations layered on top of others, not for the first animations applied. Properties
   * keyed by additive animations must be set manually or by another animation before applying the additive animations, else
   * the property values will increase continually. */

  MixBlend[MixBlend["add"] = 3] = "add";
})(MixBlend || (exports.MixBlend = MixBlend = {}));
/** Indicates whether a timeline's `alpha` is mixing out over time toward 0 (the setup or current pose value) or
 * mixing in toward 1 (the timeline's value).
 *
 * See Timeline {@link Timeline#apply(Skeleton, float, float, Array, float, MixBlend, MixDirection)}. */


var MixDirection;
exports.MixDirection = MixDirection;

(function (MixDirection) {
  MixDirection[MixDirection["mixIn"] = 0] = "mixIn";
  MixDirection[MixDirection["mixOut"] = 1] = "mixOut";
})(MixDirection || (exports.MixDirection = MixDirection = {}));

var Property = {
  rotate: 0,
  x: 1,
  y: 2,
  scaleX: 3,
  scaleY: 4,
  shearX: 5,
  shearY: 6,
  rgb: 7,
  alpha: 8,
  rgb2: 9,
  attachment: 10,
  deform: 11,
  event: 12,
  drawOrder: 13,
  ikConstraint: 14,
  transformConstraint: 15,
  pathConstraintPosition: 16,
  pathConstraintSpacing: 17,
  pathConstraintMix: 18
};
/** The interface for all timelines. */

var Timeline = /*#__PURE__*/function () {
  function Timeline(frameCount, propertyIds) {
    this.propertyIds = null;
    this.frames = null;
    this.propertyIds = propertyIds;
    this.frames = _Utils.Utils.newFloatArray(frameCount * this.getFrameEntries());
  }

  var _proto2 = Timeline.prototype;

  _proto2.getPropertyIds = function getPropertyIds() {
    return this.propertyIds;
  };

  _proto2.getFrameEntries = function getFrameEntries() {
    return 1;
  };

  _proto2.getFrameCount = function getFrameCount() {
    return this.frames.length / this.getFrameEntries();
  };

  _proto2.getDuration = function getDuration() {
    return this.frames[this.frames.length - this.getFrameEntries()];
  };

  Timeline.search1 = function search1(frames, time) {
    var n = frames.length;

    for (var i = 1; i < n; i++) {
      if (frames[i] > time) return i - 1;
    }

    return n - 1;
  };

  Timeline.search = function search(frames, time, step) {
    var n = frames.length;

    for (var i = step; i < n; i += step) {
      if (frames[i] > time) return i - step;
    }

    return n - step;
  };

  return Timeline;
}();
/** The base class for timelines that use interpolation between key frame values. */


exports.Timeline = Timeline;

var CurveTimeline = /*#__PURE__*/function (_Timeline) {
  _inheritsLoose(CurveTimeline, _Timeline);

  function CurveTimeline(frameCount, bezierCount, propertyIds) {
    var _this;

    _this = _Timeline.call(this, frameCount, propertyIds) || this;
    _this.curves = null; // type, x, y, ...

    _this.curves = _Utils.Utils.newFloatArray(frameCount + bezierCount * 18
    /*BEZIER_SIZE*/
    );
    _this.curves[frameCount - 1] = 1
    /*STEPPED*/
    ;
    return _this;
  }
  /** Sets the specified key frame to linear interpolation. */


  var _proto3 = CurveTimeline.prototype;

  _proto3.setLinear = function setLinear(frame) {
    this.curves[frame] = 0
    /*LINEAR*/
    ;
  }
  /** Sets the specified key frame to stepped interpolation. */
  ;

  _proto3.setStepped = function setStepped(frame) {
    this.curves[frame] = 1
    /*STEPPED*/
    ;
  }
  /** Shrinks the storage for Bezier curves, for use when <code>bezierCount</code> (specified in the constructor) was larger
   * than the actual number of Bezier curves. */
  ;

  _proto3.shrink = function shrink(bezierCount) {
    var size = this.getFrameCount() + bezierCount * 18
    /*BEZIER_SIZE*/
    ;

    if (this.curves.length > size) {
      var newCurves = _Utils.Utils.newFloatArray(size);

      _Utils.Utils.arrayCopy(this.curves, 0, newCurves, 0, size);

      this.curves = newCurves;
    }
  }
  /** Stores the segments for the specified Bezier curve. For timelines that modify multiple values, there may be more than
   * one curve per frame.
   * @param bezier The ordinal of this Bezier curve for this timeline, between 0 and <code>bezierCount - 1</code> (specified
   *           in the constructor), inclusive.
   * @param frame Between 0 and <code>frameCount - 1</code>, inclusive.
   * @param value The index of the value for this frame that this curve is used for.
   * @param time1 The time for the first key.
   * @param value1 The value for the first key.
   * @param cx1 The time for the first Bezier handle.
   * @param cy1 The value for the first Bezier handle.
   * @param cx2 The time of the second Bezier handle.
   * @param cy2 The value for the second Bezier handle.
   * @param time2 The time for the second key.
   * @param value2 The value for the second key. */
  ;

  _proto3.setBezier = function setBezier(bezier, frame, value, time1, value1, cx1, cy1, cx2, cy2, time2, value2) {
    var curves = this.curves;
    var i = this.getFrameCount() + bezier * 18
    /*BEZIER_SIZE*/
    ;
    if (value == 0) curves[frame] = 2
    /*BEZIER*/
    + i;
    var tmpx = (time1 - cx1 * 2 + cx2) * 0.03,
        tmpy = (value1 - cy1 * 2 + cy2) * 0.03;
    var dddx = ((cx1 - cx2) * 3 - time1 + time2) * 0.006,
        dddy = ((cy1 - cy2) * 3 - value1 + value2) * 0.006;
    var ddx = tmpx * 2 + dddx,
        ddy = tmpy * 2 + dddy;
    var dx = (cx1 - time1) * 0.3 + tmpx + dddx * 0.16666667,
        dy = (cy1 - value1) * 0.3 + tmpy + dddy * 0.16666667;
    var x = time1 + dx,
        y = value1 + dy;

    for (var n = i + 18
    /*BEZIER_SIZE*/
    ; i < n; i += 2) {
      curves[i] = x;
      curves[i + 1] = y;
      dx += ddx;
      dy += ddy;
      ddx += dddx;
      ddy += dddy;
      x += dx;
      y += dy;
    }
  }
  /** Returns the Bezier interpolated value for the specified time.
   * @param frameIndex The index into {@link #getFrames()} for the values of the frame before <code>time</code>.
   * @param valueOffset The offset from <code>frameIndex</code> to the value this curve is used for.
   * @param i The index of the Bezier segments. See {@link #getCurveType(int)}. */
  ;

  _proto3.getBezierValue = function getBezierValue(time, frameIndex, valueOffset, i) {
    var curves = this.curves;

    if (curves[i] > time) {
      var _x = this.frames[frameIndex],
          _y = this.frames[frameIndex + valueOffset];
      return _y + (time - _x) / (curves[i] - _x) * (curves[i + 1] - _y);
    }

    var n = i + 18
    /*BEZIER_SIZE*/
    ;

    for (i += 2; i < n; i += 2) {
      if (curves[i] >= time) {
        var _x2 = curves[i - 2],
            _y2 = curves[i - 1];
        return _y2 + (time - _x2) / (curves[i] - _x2) * (curves[i + 1] - _y2);
      }
    }

    frameIndex += this.getFrameEntries();
    var x = curves[n - 2],
        y = curves[n - 1];
    return y + (time - x) / (this.frames[frameIndex] - x) * (this.frames[frameIndex + valueOffset] - y);
  };

  return CurveTimeline;
}(Timeline);

exports.CurveTimeline = CurveTimeline;

var CurveTimeline1 = /*#__PURE__*/function (_CurveTimeline) {
  _inheritsLoose(CurveTimeline1, _CurveTimeline);

  function CurveTimeline1(frameCount, bezierCount, propertyId) {
    return _CurveTimeline.call(this, frameCount, bezierCount, [propertyId]) || this;
  }

  var _proto4 = CurveTimeline1.prototype;

  _proto4.getFrameEntries = function getFrameEntries() {
    return 2
    /*ENTRIES*/
    ;
  }
  /** Sets the time and value for the specified frame.
   * @param frame Between 0 and <code>frameCount</code>, inclusive.
   * @param time The frame time in seconds. */
  ;

  _proto4.setFrame = function setFrame(frame, time, value) {
    frame <<= 1;
    this.frames[frame] = time;
    this.frames[frame + 1
    /*VALUE*/
    ] = value;
  }
  /** Returns the interpolated value for the specified time. */
  ;

  _proto4.getCurveValue = function getCurveValue(time) {
    var frames = this.frames;
    var i = frames.length - 2;

    for (var ii = 2; ii <= i; ii += 2) {
      if (frames[ii] > time) {
        i = ii - 2;
        break;
      }
    }

    var curveType = this.curves[i >> 1];

    switch (curveType) {
      case 0
      /*LINEAR*/
      :
        var before = frames[i],
            value = frames[i + 1
        /*VALUE*/
        ];
        return value + (time - before) / (frames[i + 2
        /*ENTRIES*/
        ] - before) * (frames[i + 2
        /*ENTRIES*/
        + 1
        /*VALUE*/
        ] - value);

      case 1
      /*STEPPED*/
      :
        return frames[i + 1
        /*VALUE*/
        ];
    }

    return this.getBezierValue(time, i, 1
    /*VALUE*/
    , curveType - 2
    /*BEZIER*/
    );
  };

  return CurveTimeline1;
}(CurveTimeline);
/** The base class for a {@link CurveTimeline} which sets two properties. */


exports.CurveTimeline1 = CurveTimeline1;

var CurveTimeline2 = /*#__PURE__*/function (_CurveTimeline2) {
  _inheritsLoose(CurveTimeline2, _CurveTimeline2);

  /** @param bezierCount The maximum number of Bezier curves. See {@link #shrink(int)}.
   * @param propertyIds Unique identifiers for the properties the timeline modifies. */
  function CurveTimeline2(frameCount, bezierCount, propertyId1, propertyId2) {
    return _CurveTimeline2.call(this, frameCount, bezierCount, [propertyId1, propertyId2]) || this;
  }

  var _proto5 = CurveTimeline2.prototype;

  _proto5.getFrameEntries = function getFrameEntries() {
    return 3
    /*ENTRIES*/
    ;
  }
  /** Sets the time and values for the specified frame.
   * @param frame Between 0 and <code>frameCount</code>, inclusive.
   * @param time The frame time in seconds. */
  ;

  _proto5.setFrame = function setFrame(frame, time, value1, value2) {
    frame *= 3
    /*ENTRIES*/
    ;
    this.frames[frame] = time;
    this.frames[frame + 1
    /*VALUE1*/
    ] = value1;
    this.frames[frame + 2
    /*VALUE2*/
    ] = value2;
  };

  return CurveTimeline2;
}(CurveTimeline);
/** Changes a bone's local {@link Bone#rotation}. */


exports.CurveTimeline2 = CurveTimeline2;

var RotateTimeline = /*#__PURE__*/function (_CurveTimeline3) {
  _inheritsLoose(RotateTimeline, _CurveTimeline3);

  function RotateTimeline(frameCount, bezierCount, boneIndex) {
    var _this2;

    _this2 = _CurveTimeline3.call(this, frameCount, bezierCount, Property.rotate + "|" + boneIndex) || this;
    _this2.boneIndex = 0;
    _this2.boneIndex = boneIndex;
    return _this2;
  }

  var _proto6 = RotateTimeline.prototype;

  _proto6.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var bone = skeleton.bones[this.boneIndex];
    if (!bone.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      switch (blend) {
        case MixBlend.setup:
          bone.rotation = bone.data.rotation;
          return;

        case MixBlend.first:
          bone.rotation += (bone.data.rotation - bone.rotation) * alpha;
      }

      return;
    }

    var r = this.getCurveValue(time);

    switch (blend) {
      case MixBlend.setup:
        bone.rotation = bone.data.rotation + r * alpha;
        break;

      case MixBlend.first:
      case MixBlend.replace:
        r += bone.data.rotation - bone.rotation;

      case MixBlend.add:
        bone.rotation += r * alpha;
    }
  };

  return RotateTimeline;
}(CurveTimeline1);
/** Changes a bone's local {@link Bone#x} and {@link Bone#y}. */


exports.RotateTimeline = RotateTimeline;

var TranslateTimeline = /*#__PURE__*/function (_CurveTimeline4) {
  _inheritsLoose(TranslateTimeline, _CurveTimeline4);

  function TranslateTimeline(frameCount, bezierCount, boneIndex) {
    var _this3;

    _this3 = _CurveTimeline4.call(this, frameCount, bezierCount, Property.x + "|" + boneIndex, Property.y + "|" + boneIndex) || this;
    _this3.boneIndex = 0;
    _this3.boneIndex = boneIndex;
    return _this3;
  }

  var _proto7 = TranslateTimeline.prototype;

  _proto7.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var bone = skeleton.bones[this.boneIndex];
    if (!bone.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      switch (blend) {
        case MixBlend.setup:
          bone.x = bone.data.x;
          bone.y = bone.data.y;
          return;

        case MixBlend.first:
          bone.x += (bone.data.x - bone.x) * alpha;
          bone.y += (bone.data.y - bone.y) * alpha;
      }

      return;
    }

    var x = 0,
        y = 0;
    var i = Timeline.search(frames, time, 3
    /*ENTRIES*/
    );
    var curveType = this.curves[i / 3
    /*ENTRIES*/
    ];

    switch (curveType) {
      case 0
      /*LINEAR*/
      :
        var before = frames[i];
        x = frames[i + 1
        /*VALUE1*/
        ];
        y = frames[i + 2
        /*VALUE2*/
        ];
        var t = (time - before) / (frames[i + 3
        /*ENTRIES*/
        ] - before);
        x += (frames[i + 3
        /*ENTRIES*/
        + 1
        /*VALUE1*/
        ] - x) * t;
        y += (frames[i + 3
        /*ENTRIES*/
        + 2
        /*VALUE2*/
        ] - y) * t;
        break;

      case 1
      /*STEPPED*/
      :
        x = frames[i + 1
        /*VALUE1*/
        ];
        y = frames[i + 2
        /*VALUE2*/
        ];
        break;

      default:
        x = this.getBezierValue(time, i, 1
        /*VALUE1*/
        , curveType - 2
        /*BEZIER*/
        );
        y = this.getBezierValue(time, i, 2
        /*VALUE2*/
        , curveType + 18
        /*BEZIER_SIZE*/
        - 2
        /*BEZIER*/
        );
    }

    switch (blend) {
      case MixBlend.setup:
        bone.x = bone.data.x + x * alpha;
        bone.y = bone.data.y + y * alpha;
        break;

      case MixBlend.first:
      case MixBlend.replace:
        bone.x += (bone.data.x + x - bone.x) * alpha;
        bone.y += (bone.data.y + y - bone.y) * alpha;
        break;

      case MixBlend.add:
        bone.x += x * alpha;
        bone.y += y * alpha;
    }
  };

  return TranslateTimeline;
}(CurveTimeline2);
/** Changes a bone's local {@link Bone#x}. */


exports.TranslateTimeline = TranslateTimeline;

var TranslateXTimeline = /*#__PURE__*/function (_CurveTimeline5) {
  _inheritsLoose(TranslateXTimeline, _CurveTimeline5);

  function TranslateXTimeline(frameCount, bezierCount, boneIndex) {
    var _this4;

    _this4 = _CurveTimeline5.call(this, frameCount, bezierCount, Property.x + "|" + boneIndex) || this;
    _this4.boneIndex = 0;
    _this4.boneIndex = boneIndex;
    return _this4;
  }

  var _proto8 = TranslateXTimeline.prototype;

  _proto8.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var bone = skeleton.bones[this.boneIndex];
    if (!bone.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      switch (blend) {
        case MixBlend.setup:
          bone.x = bone.data.x;
          return;

        case MixBlend.first:
          bone.x += (bone.data.x - bone.x) * alpha;
      }

      return;
    }

    var x = this.getCurveValue(time);

    switch (blend) {
      case MixBlend.setup:
        bone.x = bone.data.x + x * alpha;
        break;

      case MixBlend.first:
      case MixBlend.replace:
        bone.x += (bone.data.x + x - bone.x) * alpha;
        break;

      case MixBlend.add:
        bone.x += x * alpha;
    }
  };

  return TranslateXTimeline;
}(CurveTimeline1);
/** Changes a bone's local {@link Bone#x}. */


exports.TranslateXTimeline = TranslateXTimeline;

var TranslateYTimeline = /*#__PURE__*/function (_CurveTimeline6) {
  _inheritsLoose(TranslateYTimeline, _CurveTimeline6);

  function TranslateYTimeline(frameCount, bezierCount, boneIndex) {
    var _this5;

    _this5 = _CurveTimeline6.call(this, frameCount, bezierCount, Property.y + "|" + boneIndex) || this;
    _this5.boneIndex = 0;
    _this5.boneIndex = boneIndex;
    return _this5;
  }

  var _proto9 = TranslateYTimeline.prototype;

  _proto9.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var bone = skeleton.bones[this.boneIndex];
    if (!bone.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      switch (blend) {
        case MixBlend.setup:
          bone.y = bone.data.y;
          return;

        case MixBlend.first:
          bone.y += (bone.data.y - bone.y) * alpha;
      }

      return;
    }

    var y = this.getCurveValue(time);

    switch (blend) {
      case MixBlend.setup:
        bone.y = bone.data.y + y * alpha;
        break;

      case MixBlend.first:
      case MixBlend.replace:
        bone.y += (bone.data.y + y - bone.y) * alpha;
        break;

      case MixBlend.add:
        bone.y += y * alpha;
    }
  };

  return TranslateYTimeline;
}(CurveTimeline1);
/** Changes a bone's local {@link Bone#scaleX)} and {@link Bone#scaleY}. */


exports.TranslateYTimeline = TranslateYTimeline;

var ScaleTimeline = /*#__PURE__*/function (_CurveTimeline7) {
  _inheritsLoose(ScaleTimeline, _CurveTimeline7);

  function ScaleTimeline(frameCount, bezierCount, boneIndex) {
    var _this6;

    _this6 = _CurveTimeline7.call(this, frameCount, bezierCount, Property.scaleX + "|" + boneIndex, Property.scaleY + "|" + boneIndex) || this;
    _this6.boneIndex = 0;
    _this6.boneIndex = boneIndex;
    return _this6;
  }

  var _proto10 = ScaleTimeline.prototype;

  _proto10.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var bone = skeleton.bones[this.boneIndex];
    if (!bone.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      switch (blend) {
        case MixBlend.setup:
          bone.scaleX = bone.data.scaleX;
          bone.scaleY = bone.data.scaleY;
          return;

        case MixBlend.first:
          bone.scaleX += (bone.data.scaleX - bone.scaleX) * alpha;
          bone.scaleY += (bone.data.scaleY - bone.scaleY) * alpha;
      }

      return;
    }

    var x, y;
    var i = Timeline.search(frames, time, 3
    /*ENTRIES*/
    );
    var curveType = this.curves[i / 3
    /*ENTRIES*/
    ];

    switch (curveType) {
      case 0
      /*LINEAR*/
      :
        var before = frames[i];
        x = frames[i + 1
        /*VALUE1*/
        ];
        y = frames[i + 2
        /*VALUE2*/
        ];
        var t = (time - before) / (frames[i + 3
        /*ENTRIES*/
        ] - before);
        x += (frames[i + 3
        /*ENTRIES*/
        + 1
        /*VALUE1*/
        ] - x) * t;
        y += (frames[i + 3
        /*ENTRIES*/
        + 2
        /*VALUE2*/
        ] - y) * t;
        break;

      case 1
      /*STEPPED*/
      :
        x = frames[i + 1
        /*VALUE1*/
        ];
        y = frames[i + 2
        /*VALUE2*/
        ];
        break;

      default:
        x = this.getBezierValue(time, i, 1
        /*VALUE1*/
        , curveType - 2
        /*BEZIER*/
        );
        y = this.getBezierValue(time, i, 2
        /*VALUE2*/
        , curveType + 18
        /*BEZIER_SIZE*/
        - 2
        /*BEZIER*/
        );
    }

    x *= bone.data.scaleX;
    y *= bone.data.scaleY;

    if (alpha == 1) {
      if (blend == MixBlend.add) {
        bone.scaleX += x - bone.data.scaleX;
        bone.scaleY += y - bone.data.scaleY;
      } else {
        bone.scaleX = x;
        bone.scaleY = y;
      }
    } else {
      var bx = 0,
          by = 0;

      if (direction == MixDirection.mixOut) {
        switch (blend) {
          case MixBlend.setup:
            bx = bone.data.scaleX;
            by = bone.data.scaleY;
            bone.scaleX = bx + (Math.abs(x) * _Utils.MathUtils.signum(bx) - bx) * alpha;
            bone.scaleY = by + (Math.abs(y) * _Utils.MathUtils.signum(by) - by) * alpha;
            break;

          case MixBlend.first:
          case MixBlend.replace:
            bx = bone.scaleX;
            by = bone.scaleY;
            bone.scaleX = bx + (Math.abs(x) * _Utils.MathUtils.signum(bx) - bx) * alpha;
            bone.scaleY = by + (Math.abs(y) * _Utils.MathUtils.signum(by) - by) * alpha;
            break;

          case MixBlend.add:
            bone.scaleX += (x - bone.data.scaleX) * alpha;
            bone.scaleY += (y - bone.data.scaleY) * alpha;
        }
      } else {
        switch (blend) {
          case MixBlend.setup:
            bx = Math.abs(bone.data.scaleX) * _Utils.MathUtils.signum(x);
            by = Math.abs(bone.data.scaleY) * _Utils.MathUtils.signum(y);
            bone.scaleX = bx + (x - bx) * alpha;
            bone.scaleY = by + (y - by) * alpha;
            break;

          case MixBlend.first:
          case MixBlend.replace:
            bx = Math.abs(bone.scaleX) * _Utils.MathUtils.signum(x);
            by = Math.abs(bone.scaleY) * _Utils.MathUtils.signum(y);
            bone.scaleX = bx + (x - bx) * alpha;
            bone.scaleY = by + (y - by) * alpha;
            break;

          case MixBlend.add:
            bone.scaleX += (x - bone.data.scaleX) * alpha;
            bone.scaleY += (y - bone.data.scaleY) * alpha;
        }
      }
    }
  };

  return ScaleTimeline;
}(CurveTimeline2);
/** Changes a bone's local {@link Bone#scaleX)} and {@link Bone#scaleY}. */


exports.ScaleTimeline = ScaleTimeline;

var ScaleXTimeline = /*#__PURE__*/function (_CurveTimeline8) {
  _inheritsLoose(ScaleXTimeline, _CurveTimeline8);

  function ScaleXTimeline(frameCount, bezierCount, boneIndex) {
    var _this7;

    _this7 = _CurveTimeline8.call(this, frameCount, bezierCount, Property.scaleX + "|" + boneIndex) || this;
    _this7.boneIndex = 0;
    _this7.boneIndex = boneIndex;
    return _this7;
  }

  var _proto11 = ScaleXTimeline.prototype;

  _proto11.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var bone = skeleton.bones[this.boneIndex];
    if (!bone.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      switch (blend) {
        case MixBlend.setup:
          bone.scaleX = bone.data.scaleX;
          return;

        case MixBlend.first:
          bone.scaleX += (bone.data.scaleX - bone.scaleX) * alpha;
      }

      return;
    }

    var x = this.getCurveValue(time) * bone.data.scaleX;

    if (alpha == 1) {
      if (blend == MixBlend.add) bone.scaleX += x - bone.data.scaleX;else bone.scaleX = x;
    } else {
      // Mixing out uses sign of setup or current pose, else use sign of key.
      var bx = 0;

      if (direction == MixDirection.mixOut) {
        switch (blend) {
          case MixBlend.setup:
            bx = bone.data.scaleX;
            bone.scaleX = bx + (Math.abs(x) * _Utils.MathUtils.signum(bx) - bx) * alpha;
            break;

          case MixBlend.first:
          case MixBlend.replace:
            bx = bone.scaleX;
            bone.scaleX = bx + (Math.abs(x) * _Utils.MathUtils.signum(bx) - bx) * alpha;
            break;

          case MixBlend.add:
            bone.scaleX += (x - bone.data.scaleX) * alpha;
        }
      } else {
        switch (blend) {
          case MixBlend.setup:
            bx = Math.abs(bone.data.scaleX) * _Utils.MathUtils.signum(x);
            bone.scaleX = bx + (x - bx) * alpha;
            break;

          case MixBlend.first:
          case MixBlend.replace:
            bx = Math.abs(bone.scaleX) * _Utils.MathUtils.signum(x);
            bone.scaleX = bx + (x - bx) * alpha;
            break;

          case MixBlend.add:
            bone.scaleX += (x - bone.data.scaleX) * alpha;
        }
      }
    }
  };

  return ScaleXTimeline;
}(CurveTimeline1);
/** Changes a bone's local {@link Bone#scaleX)} and {@link Bone#scaleY}. */


exports.ScaleXTimeline = ScaleXTimeline;

var ScaleYTimeline = /*#__PURE__*/function (_CurveTimeline9) {
  _inheritsLoose(ScaleYTimeline, _CurveTimeline9);

  function ScaleYTimeline(frameCount, bezierCount, boneIndex) {
    var _this8;

    _this8 = _CurveTimeline9.call(this, frameCount, bezierCount, Property.scaleY + "|" + boneIndex) || this;
    _this8.boneIndex = 0;
    _this8.boneIndex = boneIndex;
    return _this8;
  }

  var _proto12 = ScaleYTimeline.prototype;

  _proto12.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var bone = skeleton.bones[this.boneIndex];
    if (!bone.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      switch (blend) {
        case MixBlend.setup:
          bone.scaleY = bone.data.scaleY;
          return;

        case MixBlend.first:
          bone.scaleY += (bone.data.scaleY - bone.scaleY) * alpha;
      }

      return;
    }

    var y = this.getCurveValue(time) * bone.data.scaleY;

    if (alpha == 1) {
      if (blend == MixBlend.add) bone.scaleY += y - bone.data.scaleY;else bone.scaleY = y;
    } else {
      // Mixing out uses sign of setup or current pose, else use sign of key.
      var by = 0;

      if (direction == MixDirection.mixOut) {
        switch (blend) {
          case MixBlend.setup:
            by = bone.data.scaleY;
            bone.scaleY = by + (Math.abs(y) * _Utils.MathUtils.signum(by) - by) * alpha;
            break;

          case MixBlend.first:
          case MixBlend.replace:
            by = bone.scaleY;
            bone.scaleY = by + (Math.abs(y) * _Utils.MathUtils.signum(by) - by) * alpha;
            break;

          case MixBlend.add:
            bone.scaleY += (y - bone.data.scaleY) * alpha;
        }
      } else {
        switch (blend) {
          case MixBlend.setup:
            by = Math.abs(bone.data.scaleY) * _Utils.MathUtils.signum(y);
            bone.scaleY = by + (y - by) * alpha;
            break;

          case MixBlend.first:
          case MixBlend.replace:
            by = Math.abs(bone.scaleY) * _Utils.MathUtils.signum(y);
            bone.scaleY = by + (y - by) * alpha;
            break;

          case MixBlend.add:
            bone.scaleY += (y - bone.data.scaleY) * alpha;
        }
      }
    }
  };

  return ScaleYTimeline;
}(CurveTimeline1);
/** Changes a bone's local {@link Bone#shearX} and {@link Bone#shearY}. */


exports.ScaleYTimeline = ScaleYTimeline;

var ShearTimeline = /*#__PURE__*/function (_CurveTimeline10) {
  _inheritsLoose(ShearTimeline, _CurveTimeline10);

  function ShearTimeline(frameCount, bezierCount, boneIndex) {
    var _this9;

    _this9 = _CurveTimeline10.call(this, frameCount, bezierCount, Property.shearX + "|" + boneIndex, Property.shearY + "|" + boneIndex) || this;
    _this9.boneIndex = 0;
    _this9.boneIndex = boneIndex;
    return _this9;
  }

  var _proto13 = ShearTimeline.prototype;

  _proto13.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var bone = skeleton.bones[this.boneIndex];
    if (!bone.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      switch (blend) {
        case MixBlend.setup:
          bone.shearX = bone.data.shearX;
          bone.shearY = bone.data.shearY;
          return;

        case MixBlend.first:
          bone.shearX += (bone.data.shearX - bone.shearX) * alpha;
          bone.shearY += (bone.data.shearY - bone.shearY) * alpha;
      }

      return;
    }

    var x = 0,
        y = 0;
    var i = Timeline.search(frames, time, 3
    /*ENTRIES*/
    );
    var curveType = this.curves[i / 3
    /*ENTRIES*/
    ];

    switch (curveType) {
      case 0
      /*LINEAR*/
      :
        var before = frames[i];
        x = frames[i + 1
        /*VALUE1*/
        ];
        y = frames[i + 2
        /*VALUE2*/
        ];
        var t = (time - before) / (frames[i + 3
        /*ENTRIES*/
        ] - before);
        x += (frames[i + 3
        /*ENTRIES*/
        + 1
        /*VALUE1*/
        ] - x) * t;
        y += (frames[i + 3
        /*ENTRIES*/
        + 2
        /*VALUE2*/
        ] - y) * t;
        break;

      case 1
      /*STEPPED*/
      :
        x = frames[i + 1
        /*VALUE1*/
        ];
        y = frames[i + 2
        /*VALUE2*/
        ];
        break;

      default:
        x = this.getBezierValue(time, i, 1
        /*VALUE1*/
        , curveType - 2
        /*BEZIER*/
        );
        y = this.getBezierValue(time, i, 2
        /*VALUE2*/
        , curveType + 18
        /*BEZIER_SIZE*/
        - 2
        /*BEZIER*/
        );
    }

    switch (blend) {
      case MixBlend.setup:
        bone.shearX = bone.data.shearX + x * alpha;
        bone.shearY = bone.data.shearY + y * alpha;
        break;

      case MixBlend.first:
      case MixBlend.replace:
        bone.shearX += (bone.data.shearX + x - bone.shearX) * alpha;
        bone.shearY += (bone.data.shearY + y - bone.shearY) * alpha;
        break;

      case MixBlend.add:
        bone.shearX += x * alpha;
        bone.shearY += y * alpha;
    }
  };

  return ShearTimeline;
}(CurveTimeline2);
/** Changes a bone's local {@link Bone#shearX} and {@link Bone#shearY}. */


exports.ShearTimeline = ShearTimeline;

var ShearXTimeline = /*#__PURE__*/function (_CurveTimeline11) {
  _inheritsLoose(ShearXTimeline, _CurveTimeline11);

  function ShearXTimeline(frameCount, bezierCount, boneIndex) {
    var _this10;

    _this10 = _CurveTimeline11.call(this, frameCount, bezierCount, Property.shearX + "|" + boneIndex) || this;
    _this10.boneIndex = 0;
    _this10.boneIndex = boneIndex;
    return _this10;
  }

  var _proto14 = ShearXTimeline.prototype;

  _proto14.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var bone = skeleton.bones[this.boneIndex];
    if (!bone.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      switch (blend) {
        case MixBlend.setup:
          bone.shearX = bone.data.shearX;
          return;

        case MixBlend.first:
          bone.shearX += (bone.data.shearX - bone.shearX) * alpha;
      }

      return;
    }

    var x = this.getCurveValue(time);

    switch (blend) {
      case MixBlend.setup:
        bone.shearX = bone.data.shearX + x * alpha;
        break;

      case MixBlend.first:
      case MixBlend.replace:
        bone.shearX += (bone.data.shearX + x - bone.shearX) * alpha;
        break;

      case MixBlend.add:
        bone.shearX += x * alpha;
    }
  };

  return ShearXTimeline;
}(CurveTimeline1);
/** Changes a bone's local {@link Bone#shearX} and {@link Bone#shearY}. */


exports.ShearXTimeline = ShearXTimeline;

var ShearYTimeline = /*#__PURE__*/function (_CurveTimeline12) {
  _inheritsLoose(ShearYTimeline, _CurveTimeline12);

  function ShearYTimeline(frameCount, bezierCount, boneIndex) {
    var _this11;

    _this11 = _CurveTimeline12.call(this, frameCount, bezierCount, Property.shearY + "|" + boneIndex) || this;
    _this11.boneIndex = 0;
    _this11.boneIndex = boneIndex;
    return _this11;
  }

  var _proto15 = ShearYTimeline.prototype;

  _proto15.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var bone = skeleton.bones[this.boneIndex];
    if (!bone.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      switch (blend) {
        case MixBlend.setup:
          bone.shearY = bone.data.shearY;
          return;

        case MixBlend.first:
          bone.shearY += (bone.data.shearY - bone.shearY) * alpha;
      }

      return;
    }

    var y = this.getCurveValue(time);

    switch (blend) {
      case MixBlend.setup:
        bone.shearY = bone.data.shearY + y * alpha;
        break;

      case MixBlend.first:
      case MixBlend.replace:
        bone.shearY += (bone.data.shearY + y - bone.shearY) * alpha;
        break;

      case MixBlend.add:
        bone.shearY += y * alpha;
    }
  };

  return ShearYTimeline;
}(CurveTimeline1);
/** Changes a slot's {@link Slot#color}. */


exports.ShearYTimeline = ShearYTimeline;

var RGBATimeline = /*#__PURE__*/function (_CurveTimeline13) {
  _inheritsLoose(RGBATimeline, _CurveTimeline13);

  function RGBATimeline(frameCount, bezierCount, slotIndex) {
    var _this12;

    _this12 = _CurveTimeline13.call(this, frameCount, bezierCount, [Property.rgb + "|" + slotIndex, Property.alpha + "|" + slotIndex]) || this;
    _this12.slotIndex = 0;
    _this12.slotIndex = slotIndex;
    return _this12;
  }

  var _proto16 = RGBATimeline.prototype;

  _proto16.getFrameEntries = function getFrameEntries() {
    return 5
    /*ENTRIES*/
    ;
  }
  /** Sets the time in seconds, red, green, blue, and alpha for the specified key frame. */
  ;

  _proto16.setFrame = function setFrame(frame, time, r, g, b, a) {
    frame *= 5
    /*ENTRIES*/
    ;
    this.frames[frame] = time;
    this.frames[frame + 1
    /*R*/
    ] = r;
    this.frames[frame + 2
    /*G*/
    ] = g;
    this.frames[frame + 3
    /*B*/
    ] = b;
    this.frames[frame + 4
    /*A*/
    ] = a;
  };

  _proto16.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var slot = skeleton.slots[this.slotIndex];
    if (!slot.bone.active) return;
    var frames = this.frames;
    var color = slot.color;

    if (time < frames[0]) {
      var setup = slot.data.color;

      switch (blend) {
        case MixBlend.setup:
          color.setFromColor(setup);
          return;

        case MixBlend.first:
          color.add((setup.r - color.r) * alpha, (setup.g - color.g) * alpha, (setup.b - color.b) * alpha, (setup.a - color.a) * alpha);
      }

      return;
    }

    var r = 0,
        g = 0,
        b = 0,
        a = 0;
    var i = Timeline.search(frames, time, 5
    /*ENTRIES*/
    );
    var curveType = this.curves[i / 5
    /*ENTRIES*/
    ];

    switch (curveType) {
      case 0
      /*LINEAR*/
      :
        var before = frames[i];
        r = frames[i + 1
        /*R*/
        ];
        g = frames[i + 2
        /*G*/
        ];
        b = frames[i + 3
        /*B*/
        ];
        a = frames[i + 4
        /*A*/
        ];
        var t = (time - before) / (frames[i + 5
        /*ENTRIES*/
        ] - before);
        r += (frames[i + 5
        /*ENTRIES*/
        + 1
        /*R*/
        ] - r) * t;
        g += (frames[i + 5
        /*ENTRIES*/
        + 2
        /*G*/
        ] - g) * t;
        b += (frames[i + 5
        /*ENTRIES*/
        + 3
        /*B*/
        ] - b) * t;
        a += (frames[i + 5
        /*ENTRIES*/
        + 4
        /*A*/
        ] - a) * t;
        break;

      case 1
      /*STEPPED*/
      :
        r = frames[i + 1
        /*R*/
        ];
        g = frames[i + 2
        /*G*/
        ];
        b = frames[i + 3
        /*B*/
        ];
        a = frames[i + 4
        /*A*/
        ];
        break;

      default:
        r = this.getBezierValue(time, i, 1
        /*R*/
        , curveType - 2
        /*BEZIER*/
        );
        g = this.getBezierValue(time, i, 2
        /*G*/
        , curveType + 18
        /*BEZIER_SIZE*/
        - 2
        /*BEZIER*/
        );
        b = this.getBezierValue(time, i, 3
        /*B*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 2 - 2
        /*BEZIER*/
        );
        a = this.getBezierValue(time, i, 4
        /*A*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 3 - 2
        /*BEZIER*/
        );
    }

    if (alpha == 1) color.set(r, g, b, a);else {
      if (blend == MixBlend.setup) color.setFromColor(slot.data.color);
      color.add((r - color.r) * alpha, (g - color.g) * alpha, (b - color.b) * alpha, (a - color.a) * alpha);
    }
  };

  return RGBATimeline;
}(CurveTimeline);
/** Changes a slot's {@link Slot#color}. */


exports.RGBATimeline = RGBATimeline;

var RGBTimeline = /*#__PURE__*/function (_CurveTimeline14) {
  _inheritsLoose(RGBTimeline, _CurveTimeline14);

  function RGBTimeline(frameCount, bezierCount, slotIndex) {
    var _this13;

    _this13 = _CurveTimeline14.call(this, frameCount, bezierCount, [Property.rgb + "|" + slotIndex]) || this;
    _this13.slotIndex = 0;
    _this13.slotIndex = slotIndex;
    return _this13;
  }

  var _proto17 = RGBTimeline.prototype;

  _proto17.getFrameEntries = function getFrameEntries() {
    return 4
    /*ENTRIES*/
    ;
  }
  /** Sets the time in seconds, red, green, blue, and alpha for the specified key frame. */
  ;

  _proto17.setFrame = function setFrame(frame, time, r, g, b) {
    frame <<= 2;
    this.frames[frame] = time;
    this.frames[frame + 1
    /*R*/
    ] = r;
    this.frames[frame + 2
    /*G*/
    ] = g;
    this.frames[frame + 3
    /*B*/
    ] = b;
  };

  _proto17.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var slot = skeleton.slots[this.slotIndex];
    if (!slot.bone.active) return;
    var frames = this.frames;
    var color = slot.color;

    if (time < frames[0]) {
      var setup = slot.data.color;

      switch (blend) {
        case MixBlend.setup:
          color.r = setup.r;
          color.g = setup.g;
          color.b = setup.b;
          return;

        case MixBlend.first:
          color.r += (setup.r - color.r) * alpha;
          color.g += (setup.g - color.g) * alpha;
          color.b += (setup.b - color.b) * alpha;
      }

      return;
    }

    var r = 0,
        g = 0,
        b = 0;
    var i = Timeline.search(frames, time, 4
    /*ENTRIES*/
    );
    var curveType = this.curves[i >> 2];

    switch (curveType) {
      case 0
      /*LINEAR*/
      :
        var before = frames[i];
        r = frames[i + 1
        /*R*/
        ];
        g = frames[i + 2
        /*G*/
        ];
        b = frames[i + 3
        /*B*/
        ];
        var t = (time - before) / (frames[i + 4
        /*ENTRIES*/
        ] - before);
        r += (frames[i + 4
        /*ENTRIES*/
        + 1
        /*R*/
        ] - r) * t;
        g += (frames[i + 4
        /*ENTRIES*/
        + 2
        /*G*/
        ] - g) * t;
        b += (frames[i + 4
        /*ENTRIES*/
        + 3
        /*B*/
        ] - b) * t;
        break;

      case 1
      /*STEPPED*/
      :
        r = frames[i + 1
        /*R*/
        ];
        g = frames[i + 2
        /*G*/
        ];
        b = frames[i + 3
        /*B*/
        ];
        break;

      default:
        r = this.getBezierValue(time, i, 1
        /*R*/
        , curveType - 2
        /*BEZIER*/
        );
        g = this.getBezierValue(time, i, 2
        /*G*/
        , curveType + 18
        /*BEZIER_SIZE*/
        - 2
        /*BEZIER*/
        );
        b = this.getBezierValue(time, i, 3
        /*B*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 2 - 2
        /*BEZIER*/
        );
    }

    if (alpha == 1) {
      color.r = r;
      color.g = g;
      color.b = b;
    } else {
      if (blend == MixBlend.setup) {
        var _setup = slot.data.color;
        color.r = _setup.r;
        color.g = _setup.g;
        color.b = _setup.b;
      }

      color.r += (r - color.r) * alpha;
      color.g += (g - color.g) * alpha;
      color.b += (b - color.b) * alpha;
    }
  };

  return RGBTimeline;
}(CurveTimeline);
/** Changes a bone's local {@link Bone#shearX} and {@link Bone#shearY}. */


exports.RGBTimeline = RGBTimeline;

var AlphaTimeline = /*#__PURE__*/function (_CurveTimeline15) {
  _inheritsLoose(AlphaTimeline, _CurveTimeline15);

  function AlphaTimeline(frameCount, bezierCount, slotIndex) {
    var _this14;

    _this14 = _CurveTimeline15.call(this, frameCount, bezierCount, Property.alpha + "|" + slotIndex) || this;
    _this14.slotIndex = 0;
    _this14.slotIndex = slotIndex;
    return _this14;
  }

  var _proto18 = AlphaTimeline.prototype;

  _proto18.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var slot = skeleton.slots[this.slotIndex];
    if (!slot.bone.active) return;
    var color = slot.color;

    if (time < this.frames[0]) {
      // Time is before first frame.
      var setup = slot.data.color;

      switch (blend) {
        case MixBlend.setup:
          color.a = setup.a;
          return;

        case MixBlend.first:
          color.a += (setup.a - color.a) * alpha;
      }

      return;
    }

    var a = this.getCurveValue(time);
    if (alpha == 1) color.a = a;else {
      if (blend == MixBlend.setup) color.a = slot.data.color.a;
      color.a += (a - color.a) * alpha;
    }
  };

  return AlphaTimeline;
}(CurveTimeline1);
/** Changes a slot's {@link Slot#color} and {@link Slot#darkColor} for two color tinting. */


exports.AlphaTimeline = AlphaTimeline;

var RGBA2Timeline = /*#__PURE__*/function (_CurveTimeline16) {
  _inheritsLoose(RGBA2Timeline, _CurveTimeline16);

  function RGBA2Timeline(frameCount, bezierCount, slotIndex) {
    var _this15;

    _this15 = _CurveTimeline16.call(this, frameCount, bezierCount, [Property.rgb + "|" + slotIndex, Property.alpha + "|" + slotIndex, Property.rgb2 + "|" + slotIndex]) || this;
    _this15.slotIndex = 0;
    _this15.slotIndex = slotIndex;
    return _this15;
  }

  var _proto19 = RGBA2Timeline.prototype;

  _proto19.getFrameEntries = function getFrameEntries() {
    return 8
    /*ENTRIES*/
    ;
  }
  /** Sets the time in seconds, light, and dark colors for the specified key frame. */
  ;

  _proto19.setFrame = function setFrame(frame, time, r, g, b, a, r2, g2, b2) {
    frame <<= 3;
    this.frames[frame] = time;
    this.frames[frame + 1
    /*R*/
    ] = r;
    this.frames[frame + 2
    /*G*/
    ] = g;
    this.frames[frame + 3
    /*B*/
    ] = b;
    this.frames[frame + 4
    /*A*/
    ] = a;
    this.frames[frame + 5
    /*R2*/
    ] = r2;
    this.frames[frame + 6
    /*G2*/
    ] = g2;
    this.frames[frame + 7
    /*B2*/
    ] = b2;
  };

  _proto19.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var slot = skeleton.slots[this.slotIndex];
    if (!slot.bone.active) return;
    var frames = this.frames;
    var light = slot.color,
        dark = slot.darkColor;

    if (time < frames[0]) {
      var setupLight = slot.data.color,
          setupDark = slot.data.darkColor;

      switch (blend) {
        case MixBlend.setup:
          light.setFromColor(setupLight);
          dark.r = setupDark.r;
          dark.g = setupDark.g;
          dark.b = setupDark.b;
          return;

        case MixBlend.first:
          light.add((setupLight.r - light.r) * alpha, (setupLight.g - light.g) * alpha, (setupLight.b - light.b) * alpha, (setupLight.a - light.a) * alpha);
          dark.r += (setupDark.r - dark.r) * alpha;
          dark.g += (setupDark.g - dark.g) * alpha;
          dark.b += (setupDark.b - dark.b) * alpha;
      }

      return;
    }

    var r = 0,
        g = 0,
        b = 0,
        a = 0,
        r2 = 0,
        g2 = 0,
        b2 = 0;
    var i = Timeline.search(frames, time, 8
    /*ENTRIES*/
    );
    var curveType = this.curves[i >> 3];

    switch (curveType) {
      case 0
      /*LINEAR*/
      :
        var before = frames[i];
        r = frames[i + 1
        /*R*/
        ];
        g = frames[i + 2
        /*G*/
        ];
        b = frames[i + 3
        /*B*/
        ];
        a = frames[i + 4
        /*A*/
        ];
        r2 = frames[i + 5
        /*R2*/
        ];
        g2 = frames[i + 6
        /*G2*/
        ];
        b2 = frames[i + 7
        /*B2*/
        ];
        var t = (time - before) / (frames[i + 8
        /*ENTRIES*/
        ] - before);
        r += (frames[i + 8
        /*ENTRIES*/
        + 1
        /*R*/
        ] - r) * t;
        g += (frames[i + 8
        /*ENTRIES*/
        + 2
        /*G*/
        ] - g) * t;
        b += (frames[i + 8
        /*ENTRIES*/
        + 3
        /*B*/
        ] - b) * t;
        a += (frames[i + 8
        /*ENTRIES*/
        + 4
        /*A*/
        ] - a) * t;
        r2 += (frames[i + 8
        /*ENTRIES*/
        + 5
        /*R2*/
        ] - r2) * t;
        g2 += (frames[i + 8
        /*ENTRIES*/
        + 6
        /*G2*/
        ] - g2) * t;
        b2 += (frames[i + 8
        /*ENTRIES*/
        + 7
        /*B2*/
        ] - b2) * t;
        break;

      case 1
      /*STEPPED*/
      :
        r = frames[i + 1
        /*R*/
        ];
        g = frames[i + 2
        /*G*/
        ];
        b = frames[i + 3
        /*B*/
        ];
        a = frames[i + 4
        /*A*/
        ];
        r2 = frames[i + 5
        /*R2*/
        ];
        g2 = frames[i + 6
        /*G2*/
        ];
        b2 = frames[i + 7
        /*B2*/
        ];
        break;

      default:
        r = this.getBezierValue(time, i, 1
        /*R*/
        , curveType - 2
        /*BEZIER*/
        );
        g = this.getBezierValue(time, i, 2
        /*G*/
        , curveType + 18
        /*BEZIER_SIZE*/
        - 2
        /*BEZIER*/
        );
        b = this.getBezierValue(time, i, 3
        /*B*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 2 - 2
        /*BEZIER*/
        );
        a = this.getBezierValue(time, i, 4
        /*A*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 3 - 2
        /*BEZIER*/
        );
        r2 = this.getBezierValue(time, i, 5
        /*R2*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 4 - 2
        /*BEZIER*/
        );
        g2 = this.getBezierValue(time, i, 6
        /*G2*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 5 - 2
        /*BEZIER*/
        );
        b2 = this.getBezierValue(time, i, 7
        /*B2*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 6 - 2
        /*BEZIER*/
        );
    }

    if (alpha == 1) {
      light.set(r, g, b, a);
      dark.r = r2;
      dark.g = g2;
      dark.b = b2;
    } else {
      if (blend == MixBlend.setup) {
        light.setFromColor(slot.data.color);
        var _setupDark = slot.data.darkColor;
        dark.r = _setupDark.r;
        dark.g = _setupDark.g;
        dark.b = _setupDark.b;
      }

      light.add((r - light.r) * alpha, (g - light.g) * alpha, (b - light.b) * alpha, (a - light.a) * alpha);
      dark.r += (r2 - dark.r) * alpha;
      dark.g += (g2 - dark.g) * alpha;
      dark.b += (b2 - dark.b) * alpha;
    }
  };

  return RGBA2Timeline;
}(CurveTimeline);
/** Changes a slot's {@link Slot#color} and {@link Slot#darkColor} for two color tinting. */


exports.RGBA2Timeline = RGBA2Timeline;

var RGB2Timeline = /*#__PURE__*/function (_CurveTimeline17) {
  _inheritsLoose(RGB2Timeline, _CurveTimeline17);

  function RGB2Timeline(frameCount, bezierCount, slotIndex) {
    var _this16;

    _this16 = _CurveTimeline17.call(this, frameCount, bezierCount, [Property.rgb + "|" + slotIndex, Property.rgb2 + "|" + slotIndex]) || this;
    _this16.slotIndex = 0;
    _this16.slotIndex = slotIndex;
    return _this16;
  }

  var _proto20 = RGB2Timeline.prototype;

  _proto20.getFrameEntries = function getFrameEntries() {
    return 7
    /*ENTRIES*/
    ;
  }
  /** Sets the time in seconds, light, and dark colors for the specified key frame. */
  ;

  _proto20.setFrame = function setFrame(frame, time, r, g, b, r2, g2, b2) {
    frame *= 7
    /*ENTRIES*/
    ;
    this.frames[frame] = time;
    this.frames[frame + 1
    /*R*/
    ] = r;
    this.frames[frame + 2
    /*G*/
    ] = g;
    this.frames[frame + 3
    /*B*/
    ] = b;
    this.frames[frame + 4
    /*R2*/
    ] = r2;
    this.frames[frame + 5
    /*G2*/
    ] = g2;
    this.frames[frame + 6
    /*B2*/
    ] = b2;
  };

  _proto20.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var slot = skeleton.slots[this.slotIndex];
    if (!slot.bone.active) return;
    var frames = this.frames;
    var light = slot.color,
        dark = slot.darkColor;

    if (time < frames[0]) {
      var setupLight = slot.data.color,
          setupDark = slot.data.darkColor;

      switch (blend) {
        case MixBlend.setup:
          light.r = setupLight.r;
          light.g = setupLight.g;
          light.b = setupLight.b;
          dark.r = setupDark.r;
          dark.g = setupDark.g;
          dark.b = setupDark.b;
          return;

        case MixBlend.first:
          light.r += (setupLight.r - light.r) * alpha;
          light.g += (setupLight.g - light.g) * alpha;
          light.b += (setupLight.b - light.b) * alpha;
          dark.r += (setupDark.r - dark.r) * alpha;
          dark.g += (setupDark.g - dark.g) * alpha;
          dark.b += (setupDark.b - dark.b) * alpha;
      }

      return;
    }

    var r = 0,
        g = 0,
        b = 0,
        a = 0,
        r2 = 0,
        g2 = 0,
        b2 = 0;
    var i = Timeline.search(frames, time, 7
    /*ENTRIES*/
    );
    var curveType = this.curves[i / 7
    /*ENTRIES*/
    ];

    switch (curveType) {
      case 0
      /*LINEAR*/
      :
        var before = frames[i];
        r = frames[i + 1
        /*R*/
        ];
        g = frames[i + 2
        /*G*/
        ];
        b = frames[i + 3
        /*B*/
        ];
        r2 = frames[i + 4
        /*R2*/
        ];
        g2 = frames[i + 5
        /*G2*/
        ];
        b2 = frames[i + 6
        /*B2*/
        ];
        var t = (time - before) / (frames[i + 7
        /*ENTRIES*/
        ] - before);
        r += (frames[i + 7
        /*ENTRIES*/
        + 1
        /*R*/
        ] - r) * t;
        g += (frames[i + 7
        /*ENTRIES*/
        + 2
        /*G*/
        ] - g) * t;
        b += (frames[i + 7
        /*ENTRIES*/
        + 3
        /*B*/
        ] - b) * t;
        r2 += (frames[i + 7
        /*ENTRIES*/
        + 4
        /*R2*/
        ] - r2) * t;
        g2 += (frames[i + 7
        /*ENTRIES*/
        + 5
        /*G2*/
        ] - g2) * t;
        b2 += (frames[i + 7
        /*ENTRIES*/
        + 6
        /*B2*/
        ] - b2) * t;
        break;

      case 1
      /*STEPPED*/
      :
        r = frames[i + 1
        /*R*/
        ];
        g = frames[i + 2
        /*G*/
        ];
        b = frames[i + 3
        /*B*/
        ];
        r2 = frames[i + 4
        /*R2*/
        ];
        g2 = frames[i + 5
        /*G2*/
        ];
        b2 = frames[i + 6
        /*B2*/
        ];
        break;

      default:
        r = this.getBezierValue(time, i, 1
        /*R*/
        , curveType - 2
        /*BEZIER*/
        );
        g = this.getBezierValue(time, i, 2
        /*G*/
        , curveType + 18
        /*BEZIER_SIZE*/
        - 2
        /*BEZIER*/
        );
        b = this.getBezierValue(time, i, 3
        /*B*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 2 - 2
        /*BEZIER*/
        );
        r2 = this.getBezierValue(time, i, 4
        /*R2*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 3 - 2
        /*BEZIER*/
        );
        g2 = this.getBezierValue(time, i, 5
        /*G2*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 4 - 2
        /*BEZIER*/
        );
        b2 = this.getBezierValue(time, i, 6
        /*B2*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 5 - 2
        /*BEZIER*/
        );
    }

    if (alpha == 1) {
      light.r = r;
      light.g = g;
      light.b = b;
      dark.r = r2;
      dark.g = g2;
      dark.b = b2;
    } else {
      if (blend == MixBlend.setup) {
        var _setupLight = slot.data.color,
            _setupDark2 = slot.data.darkColor;
        light.r = _setupLight.r;
        light.g = _setupLight.g;
        light.b = _setupLight.b;
        dark.r = _setupDark2.r;
        dark.g = _setupDark2.g;
        dark.b = _setupDark2.b;
      }

      light.r += (r - light.r) * alpha;
      light.g += (g - light.g) * alpha;
      light.b += (b - light.b) * alpha;
      dark.r += (r2 - dark.r) * alpha;
      dark.g += (g2 - dark.g) * alpha;
      dark.b += (b2 - dark.b) * alpha;
    }
  };

  return RGB2Timeline;
}(CurveTimeline);
/** Changes a slot's {@link Slot#attachment}. */


exports.RGB2Timeline = RGB2Timeline;

var AttachmentTimeline = /*#__PURE__*/function (_Timeline2) {
  _inheritsLoose(AttachmentTimeline, _Timeline2);

  function AttachmentTimeline(frameCount, slotIndex) {
    var _this17;

    _this17 = _Timeline2.call(this, frameCount, [Property.attachment + "|" + slotIndex]) || this;
    _this17.slotIndex = 0;
    _this17.slotIndex = slotIndex;
    _this17.attachmentNames = new Array(frameCount);
    return _this17;
  }

  var _proto21 = AttachmentTimeline.prototype;

  _proto21.getFrameCount = function getFrameCount() {
    return this.frames.length;
  }
  /** Sets the time in seconds and the attachment name for the specified key frame. */
  ;

  _proto21.setFrame = function setFrame(frame, time, attachmentName) {
    this.frames[frame] = time;
    this.attachmentNames[frame] = attachmentName;
  };

  _proto21.apply = function apply(skeleton, lastTime, time, events, alpha, blend, direction) {
    var slot = skeleton.slots[this.slotIndex];
    if (!slot.bone.active) return;

    if (direction == MixDirection.mixOut) {
      if (blend == MixBlend.setup) this.setAttachment(skeleton, slot, slot.data.attachmentName);
      return;
    }

    if (time < this.frames[0]) {
      if (blend == MixBlend.setup || blend == MixBlend.first) this.setAttachment(skeleton, slot, slot.data.attachmentName);
      return;
    }

    this.setAttachment(skeleton, slot, this.attachmentNames[Timeline.search1(this.frames, time)]);
  };

  _proto21.setAttachment = function setAttachment(skeleton, slot, attachmentName) {
    slot.setAttachment(!attachmentName ? null : skeleton.getAttachment(this.slotIndex, attachmentName));
  };

  return AttachmentTimeline;
}(Timeline);
/** Changes a slot's {@link Slot#deform} to deform a {@link VertexAttachment}. */


exports.AttachmentTimeline = AttachmentTimeline;

var DeformTimeline = /*#__PURE__*/function (_CurveTimeline18) {
  _inheritsLoose(DeformTimeline, _CurveTimeline18);

  function DeformTimeline(frameCount, bezierCount, slotIndex, attachment) {
    var _this18;

    _this18 = _CurveTimeline18.call(this, frameCount, bezierCount, [Property.deform + "|" + slotIndex + "|" + attachment.id]) || this;
    _this18.slotIndex = 0;
    /** The attachment that will be deformed. */

    _this18.attachment = null;
    /** The vertices for each key frame. */

    _this18.vertices = null;
    _this18.slotIndex = slotIndex;
    _this18.attachment = attachment;
    _this18.vertices = new Array(frameCount);
    return _this18;
  }

  var _proto22 = DeformTimeline.prototype;

  _proto22.getFrameCount = function getFrameCount() {
    return this.frames.length;
  }
  /** Sets the time in seconds and the vertices for the specified key frame.
   * @param vertices Vertex positions for an unweighted VertexAttachment, or deform offsets if it has weights. */
  ;

  _proto22.setFrame = function setFrame(frame, time, vertices) {
    this.frames[frame] = time;
    this.vertices[frame] = vertices;
  }
  /** @param value1 Ignored (0 is used for a deform timeline).
   * @param value2 Ignored (1 is used for a deform timeline). */
  ;

  _proto22.setBezier = function setBezier(bezier, frame, value, time1, value1, cx1, cy1, cx2, cy2, time2, value2) {
    var curves = this.curves;
    var i = this.getFrameCount() + bezier * 18
    /*BEZIER_SIZE*/
    ;
    if (value == 0) curves[frame] = 2
    /*BEZIER*/
    + i;
    var tmpx = (time1 - cx1 * 2 + cx2) * 0.03,
        tmpy = cy2 * 0.03 - cy1 * 0.06;
    var dddx = ((cx1 - cx2) * 3 - time1 + time2) * 0.006,
        dddy = (cy1 - cy2 + 0.33333333) * 0.018;
    var ddx = tmpx * 2 + dddx,
        ddy = tmpy * 2 + dddy;
    var dx = (cx1 - time1) * 0.3 + tmpx + dddx * 0.16666667,
        dy = cy1 * 0.3 + tmpy + dddy * 0.16666667;
    var x = time1 + dx,
        y = dy;

    for (var n = i + 18
    /*BEZIER_SIZE*/
    ; i < n; i += 2) {
      curves[i] = x;
      curves[i + 1] = y;
      dx += ddx;
      dy += ddy;
      ddx += dddx;
      ddy += dddy;
      x += dx;
      y += dy;
    }
  };

  _proto22.getCurvePercent = function getCurvePercent(time, frame) {
    var curves = this.curves;
    var i = curves[frame];

    switch (i) {
      case 0
      /*LINEAR*/
      :
        var _x3 = this.frames[frame];
        return (time - _x3) / (this.frames[frame + this.getFrameEntries()] - _x3);

      case 1
      /*STEPPED*/
      :
        return 0;
    }

    i -= 2
    /*BEZIER*/
    ;

    if (curves[i] > time) {
      var _x4 = this.frames[frame];
      return curves[i + 1] * (time - _x4) / (curves[i] - _x4);
    }

    var n = i + 18
    /*BEZIER_SIZE*/
    ;

    for (i += 2; i < n; i += 2) {
      if (curves[i] >= time) {
        var _x5 = curves[i - 2],
            _y3 = curves[i - 1];
        return _y3 + (time - _x5) / (curves[i] - _x5) * (curves[i + 1] - _y3);
      }
    }

    var x = curves[n - 2],
        y = curves[n - 1];
    return y + (1 - y) * (time - x) / (this.frames[frame + this.getFrameEntries()] - x);
  };

  _proto22.apply = function apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
    var slot = skeleton.slots[this.slotIndex];
    if (!slot.bone.active) return;
    var slotAttachment = slot.getAttachment();
    if (!(slotAttachment instanceof _Attachment.VertexAttachment) || slotAttachment.deformAttachment != this.attachment) return;
    var deform = slot.deform;
    if (deform.length == 0) blend = MixBlend.setup;
    var vertices = this.vertices;
    var vertexCount = vertices[0].length;
    var frames = this.frames;

    if (time < frames[0]) {
      var vertexAttachment = slotAttachment;

      switch (blend) {
        case MixBlend.setup:
          deform.length = 0;
          return;

        case MixBlend.first:
          if (alpha == 1) {
            deform.length = 0;
            return;
          }

          deform.length = vertexCount;

          if (!vertexAttachment.bones) {
            // Unweighted vertex positions.
            var setupVertices = vertexAttachment.vertices;

            for (var i = 0; i < vertexCount; i++) {
              deform[i] += (setupVertices[i] - deform[i]) * alpha;
            }
          } else {
            // Weighted deform offsets.
            alpha = 1 - alpha;

            for (var i = 0; i < vertexCount; i++) {
              deform[i] *= alpha;
            }
          }

      }

      return;
    }

    deform.length = vertexCount;

    if (time >= frames[frames.length - 1]) {
      // Time is after last frame.
      var lastVertices = vertices[frames.length - 1];

      if (alpha == 1) {
        if (blend == MixBlend.add) {
          var _vertexAttachment = slotAttachment;

          if (!_vertexAttachment.bones) {
            // Unweighted vertex positions, with alpha.
            var _setupVertices = _vertexAttachment.vertices;

            for (var _i = 0; _i < vertexCount; _i++) {
              deform[_i] += lastVertices[_i] - _setupVertices[_i];
            }
          } else {
            // Weighted deform offsets, with alpha.
            for (var _i2 = 0; _i2 < vertexCount; _i2++) {
              deform[_i2] += lastVertices[_i2];
            }
          }
        } else _Utils.Utils.arrayCopy(lastVertices, 0, deform, 0, vertexCount);
      } else {
        switch (blend) {
          case MixBlend.setup:
            {
              var _vertexAttachment3 = slotAttachment;

              if (!_vertexAttachment3.bones) {
                // Unweighted vertex positions, with alpha.
                var _setupVertices2 = _vertexAttachment3.vertices;

                for (var _i3 = 0; _i3 < vertexCount; _i3++) {
                  var setup = _setupVertices2[_i3];
                  deform[_i3] = setup + (lastVertices[_i3] - setup) * alpha;
                }
              } else {
                // Weighted deform offsets, with alpha.
                for (var _i4 = 0; _i4 < vertexCount; _i4++) {
                  deform[_i4] = lastVertices[_i4] * alpha;
                }
              }

              break;
            }

          case MixBlend.first:
          case MixBlend.replace:
            for (var _i5 = 0; _i5 < vertexCount; _i5++) {
              deform[_i5] += (lastVertices[_i5] - deform[_i5]) * alpha;
            }

            break;

          case MixBlend.add:
            var _vertexAttachment2 = slotAttachment;

            if (!_vertexAttachment2.bones) {
              // Unweighted vertex positions, with alpha.
              var _setupVertices3 = _vertexAttachment2.vertices;

              for (var _i6 = 0; _i6 < vertexCount; _i6++) {
                deform[_i6] += (lastVertices[_i6] - _setupVertices3[_i6]) * alpha;
              }
            } else {
              // Weighted deform offsets, with alpha.
              for (var _i7 = 0; _i7 < vertexCount; _i7++) {
                deform[_i7] += lastVertices[_i7] * alpha;
              }
            }

        }
      }

      return;
    } // Interpolate between the previous frame and the current frame.


    var frame = Timeline.search1(frames, time);
    var percent = this.getCurvePercent(time, frame);
    var prevVertices = vertices[frame];
    var nextVertices = vertices[frame + 1];

    if (alpha == 1) {
      if (blend == MixBlend.add) {
        var _vertexAttachment4 = slotAttachment;

        if (!_vertexAttachment4.bones) {
          // Unweighted vertex positions, with alpha.
          var _setupVertices4 = _vertexAttachment4.vertices;

          for (var _i8 = 0; _i8 < vertexCount; _i8++) {
            var prev = prevVertices[_i8];
            deform[_i8] += prev + (nextVertices[_i8] - prev) * percent - _setupVertices4[_i8];
          }
        } else {
          // Weighted deform offsets, with alpha.
          for (var _i9 = 0; _i9 < vertexCount; _i9++) {
            var _prev = prevVertices[_i9];
            deform[_i9] += _prev + (nextVertices[_i9] - _prev) * percent;
          }
        }
      } else {
        for (var _i10 = 0; _i10 < vertexCount; _i10++) {
          var _prev2 = prevVertices[_i10];
          deform[_i10] = _prev2 + (nextVertices[_i10] - _prev2) * percent;
        }
      }
    } else {
      switch (blend) {
        case MixBlend.setup:
          {
            var _vertexAttachment6 = slotAttachment;

            if (!_vertexAttachment6.bones) {
              // Unweighted vertex positions, with alpha.
              var _setupVertices5 = _vertexAttachment6.vertices;

              for (var _i11 = 0; _i11 < vertexCount; _i11++) {
                var _prev3 = prevVertices[_i11],
                    _setup2 = _setupVertices5[_i11];
                deform[_i11] = _setup2 + (_prev3 + (nextVertices[_i11] - _prev3) * percent - _setup2) * alpha;
              }
            } else {
              // Weighted deform offsets, with alpha.
              for (var _i12 = 0; _i12 < vertexCount; _i12++) {
                var _prev4 = prevVertices[_i12];
                deform[_i12] = (_prev4 + (nextVertices[_i12] - _prev4) * percent) * alpha;
              }
            }

            break;
          }

        case MixBlend.first:
        case MixBlend.replace:
          for (var _i13 = 0; _i13 < vertexCount; _i13++) {
            var _prev5 = prevVertices[_i13];
            deform[_i13] += (_prev5 + (nextVertices[_i13] - _prev5) * percent - deform[_i13]) * alpha;
          }

          break;

        case MixBlend.add:
          var _vertexAttachment5 = slotAttachment;

          if (!_vertexAttachment5.bones) {
            // Unweighted vertex positions, with alpha.
            var _setupVertices6 = _vertexAttachment5.vertices;

            for (var _i14 = 0; _i14 < vertexCount; _i14++) {
              var _prev6 = prevVertices[_i14];
              deform[_i14] += (_prev6 + (nextVertices[_i14] - _prev6) * percent - _setupVertices6[_i14]) * alpha;
            }
          } else {
            // Weighted deform offsets, with alpha.
            for (var _i15 = 0; _i15 < vertexCount; _i15++) {
              var _prev7 = prevVertices[_i15];
              deform[_i15] += (_prev7 + (nextVertices[_i15] - _prev7) * percent) * alpha;
            }
          }

      }
    }
  };

  return DeformTimeline;
}(CurveTimeline);
/** Fires an {@link Event} when specific animation times are reached. */


exports.DeformTimeline = DeformTimeline;

var EventTimeline = /*#__PURE__*/function (_Timeline3) {
  _inheritsLoose(EventTimeline, _Timeline3);

  function EventTimeline(frameCount) {
    var _this19;

    _this19 = _Timeline3.call(this, frameCount, EventTimeline.propertyIds) || this;
    /** The event for each key frame. */

    _this19.events = null;
    _this19.events = new Array(frameCount);
    return _this19;
  }

  var _proto23 = EventTimeline.prototype;

  _proto23.getFrameCount = function getFrameCount() {
    return this.frames.length;
  }
  /** Sets the time in seconds and the event for the specified key frame. */
  ;

  _proto23.setFrame = function setFrame(frame, event) {
    this.frames[frame] = event.time;
    this.events[frame] = event;
  }
  /** Fires events for frames > `lastTime` and <= `time`. */
  ;

  _proto23.apply = function apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
    if (!firedEvents) return;
    var frames = this.frames;
    var frameCount = this.frames.length;

    if (lastTime > time) {
      // Fire events after last time for looped animations.
      this.apply(skeleton, lastTime, Number.MAX_VALUE, firedEvents, alpha, blend, direction);
      lastTime = -1;
    } else if (lastTime >= frames[frameCount - 1]) // Last time is after last frame.
      return;

    if (time < frames[0]) return; // Time is before first frame.

    var i = 0;
    if (lastTime < frames[0]) i = 0;else {
      i = Timeline.search1(frames, lastTime) + 1;
      var frameTime = frames[i];

      while (i > 0) {
        // Fire multiple events with the same frame.
        if (frames[i - 1] != frameTime) break;
        i--;
      }
    }

    for (; i < frameCount && time >= frames[i]; i++) {
      firedEvents.push(this.events[i]);
    }
  };

  return EventTimeline;
}(Timeline);

exports.EventTimeline = EventTimeline;
EventTimeline.propertyIds = ["" + Property.event];
/** Changes a skeleton's {@link Skeleton#drawOrder}. */

var DrawOrderTimeline = /*#__PURE__*/function (_Timeline4) {
  _inheritsLoose(DrawOrderTimeline, _Timeline4);

  function DrawOrderTimeline(frameCount) {
    var _this20;

    _this20 = _Timeline4.call(this, frameCount, DrawOrderTimeline.propertyIds) || this;
    /** The draw order for each key frame. See {@link #setFrame(int, float, int[])}. */

    _this20.drawOrders = null;
    _this20.drawOrders = new Array(frameCount);
    return _this20;
  }

  var _proto24 = DrawOrderTimeline.prototype;

  _proto24.getFrameCount = function getFrameCount() {
    return this.frames.length;
  }
  /** Sets the time in seconds and the draw order for the specified key frame.
   * @param drawOrder For each slot in {@link Skeleton#slots}, the index of the new draw order. May be null to use setup pose
   *           draw order. */
  ;

  _proto24.setFrame = function setFrame(frame, time, drawOrder) {
    this.frames[frame] = time;
    this.drawOrders[frame] = drawOrder;
  };

  _proto24.apply = function apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
    if (direction == MixDirection.mixOut) {
      if (blend == MixBlend.setup) _Utils.Utils.arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
      return;
    }

    if (time < this.frames[0]) {
      if (blend == MixBlend.setup || blend == MixBlend.first) _Utils.Utils.arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
      return;
    }

    var drawOrderToSetupIndex = this.drawOrders[Timeline.search1(this.frames, time)];
    if (!drawOrderToSetupIndex) _Utils.Utils.arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);else {
      var drawOrder = skeleton.drawOrder;
      var slots = skeleton.slots;

      for (var i = 0, n = drawOrderToSetupIndex.length; i < n; i++) {
        drawOrder[i] = slots[drawOrderToSetupIndex[i]];
      }
    }
  };

  return DrawOrderTimeline;
}(Timeline);

exports.DrawOrderTimeline = DrawOrderTimeline;
DrawOrderTimeline.propertyIds = ["" + Property.drawOrder];
/** Changes an IK constraint's {@link IkConstraint#mix}, {@link IkConstraint#softness},
 * {@link IkConstraint#bendDirection}, {@link IkConstraint#stretch}, and {@link IkConstraint#compress}. */

var IkConstraintTimeline = /*#__PURE__*/function (_CurveTimeline19) {
  _inheritsLoose(IkConstraintTimeline, _CurveTimeline19);

  function IkConstraintTimeline(frameCount, bezierCount, ikConstraintIndex) {
    var _this21;

    _this21 = _CurveTimeline19.call(this, frameCount, bezierCount, [Property.ikConstraint + "|" + ikConstraintIndex]) || this;
    /** The index of the IK constraint slot in {@link Skeleton#ikConstraints} that will be changed. */

    _this21.ikConstraintIndex = 0;
    _this21.ikConstraintIndex = ikConstraintIndex;
    return _this21;
  }

  var _proto25 = IkConstraintTimeline.prototype;

  _proto25.getFrameEntries = function getFrameEntries() {
    return 6
    /*ENTRIES*/
    ;
  }
  /** Sets the time in seconds, mix, softness, bend direction, compress, and stretch for the specified key frame. */
  ;

  _proto25.setFrame = function setFrame(frame, time, mix, softness, bendDirection, compress, stretch) {
    frame *= 6
    /*ENTRIES*/
    ;
    this.frames[frame] = time;
    this.frames[frame + 1
    /*MIX*/
    ] = mix;
    this.frames[frame + 2
    /*SOFTNESS*/
    ] = softness;
    this.frames[frame + 3
    /*BEND_DIRECTION*/
    ] = bendDirection;
    this.frames[frame + 4
    /*COMPRESS*/
    ] = compress ? 1 : 0;
    this.frames[frame + 5
    /*STRETCH*/
    ] = stretch ? 1 : 0;
  };

  _proto25.apply = function apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
    var constraint = skeleton.ikConstraints[this.ikConstraintIndex];
    if (!constraint.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      switch (blend) {
        case MixBlend.setup:
          constraint.mix = constraint.data.mix;
          constraint.softness = constraint.data.softness;
          constraint.bendDirection = constraint.data.bendDirection;
          constraint.compress = constraint.data.compress;
          constraint.stretch = constraint.data.stretch;
          return;

        case MixBlend.first:
          constraint.mix += (constraint.data.mix - constraint.mix) * alpha;
          constraint.softness += (constraint.data.softness - constraint.softness) * alpha;
          constraint.bendDirection = constraint.data.bendDirection;
          constraint.compress = constraint.data.compress;
          constraint.stretch = constraint.data.stretch;
      }

      return;
    }

    var mix = 0,
        softness = 0;
    var i = Timeline.search(frames, time, 6
    /*ENTRIES*/
    );
    var curveType = this.curves[i / 6
    /*ENTRIES*/
    ];

    switch (curveType) {
      case 0
      /*LINEAR*/
      :
        var before = frames[i];
        mix = frames[i + 1
        /*MIX*/
        ];
        softness = frames[i + 2
        /*SOFTNESS*/
        ];
        var t = (time - before) / (frames[i + 6
        /*ENTRIES*/
        ] - before);
        mix += (frames[i + 6
        /*ENTRIES*/
        + 1
        /*MIX*/
        ] - mix) * t;
        softness += (frames[i + 6
        /*ENTRIES*/
        + 2
        /*SOFTNESS*/
        ] - softness) * t;
        break;

      case 1
      /*STEPPED*/
      :
        mix = frames[i + 1
        /*MIX*/
        ];
        softness = frames[i + 2
        /*SOFTNESS*/
        ];
        break;

      default:
        mix = this.getBezierValue(time, i, 1
        /*MIX*/
        , curveType - 2
        /*BEZIER*/
        );
        softness = this.getBezierValue(time, i, 2
        /*SOFTNESS*/
        , curveType + 18
        /*BEZIER_SIZE*/
        - 2
        /*BEZIER*/
        );
    }

    if (blend == MixBlend.setup) {
      constraint.mix = constraint.data.mix + (mix - constraint.data.mix) * alpha;
      constraint.softness = constraint.data.softness + (softness - constraint.data.softness) * alpha;

      if (direction == MixDirection.mixOut) {
        constraint.bendDirection = constraint.data.bendDirection;
        constraint.compress = constraint.data.compress;
        constraint.stretch = constraint.data.stretch;
      } else {
        constraint.bendDirection = frames[i + 3
        /*BEND_DIRECTION*/
        ];
        constraint.compress = frames[i + 4
        /*COMPRESS*/
        ] != 0;
        constraint.stretch = frames[i + 5
        /*STRETCH*/
        ] != 0;
      }
    } else {
      constraint.mix += (mix - constraint.mix) * alpha;
      constraint.softness += (softness - constraint.softness) * alpha;

      if (direction == MixDirection.mixIn) {
        constraint.bendDirection = frames[i + 3
        /*BEND_DIRECTION*/
        ];
        constraint.compress = frames[i + 4
        /*COMPRESS*/
        ] != 0;
        constraint.stretch = frames[i + 5
        /*STRETCH*/
        ] != 0;
      }
    }
  };

  return IkConstraintTimeline;
}(CurveTimeline);
/** Changes a transform constraint's {@link TransformConstraint#rotateMix}, {@link TransformConstraint#translateMix},
 * {@link TransformConstraint#scaleMix}, and {@link TransformConstraint#shearMix}. */


exports.IkConstraintTimeline = IkConstraintTimeline;

var TransformConstraintTimeline = /*#__PURE__*/function (_CurveTimeline20) {
  _inheritsLoose(TransformConstraintTimeline, _CurveTimeline20);

  function TransformConstraintTimeline(frameCount, bezierCount, transformConstraintIndex) {
    var _this22;

    _this22 = _CurveTimeline20.call(this, frameCount, bezierCount, [Property.transformConstraint + "|" + transformConstraintIndex]) || this;
    /** The index of the transform constraint slot in {@link Skeleton#transformConstraints} that will be changed. */

    _this22.transformConstraintIndex = 0;
    _this22.transformConstraintIndex = transformConstraintIndex;
    return _this22;
  }

  var _proto26 = TransformConstraintTimeline.prototype;

  _proto26.getFrameEntries = function getFrameEntries() {
    return 7
    /*ENTRIES*/
    ;
  }
  /** The time in seconds, rotate mix, translate mix, scale mix, and shear mix for the specified key frame. */
  ;

  _proto26.setFrame = function setFrame(frame, time, mixRotate, mixX, mixY, mixScaleX, mixScaleY, mixShearY) {
    var frames = this.frames;
    frame *= 7
    /*ENTRIES*/
    ;
    frames[frame] = time;
    frames[frame + 1
    /*ROTATE*/
    ] = mixRotate;
    frames[frame + 2
    /*X*/
    ] = mixX;
    frames[frame + 3
    /*Y*/
    ] = mixY;
    frames[frame + 4
    /*SCALEX*/
    ] = mixScaleX;
    frames[frame + 5
    /*SCALEY*/
    ] = mixScaleY;
    frames[frame + 6
    /*SHEARY*/
    ] = mixShearY;
  };

  _proto26.apply = function apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
    var constraint = skeleton.transformConstraints[this.transformConstraintIndex];
    if (!constraint.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      var data = constraint.data;

      switch (blend) {
        case MixBlend.setup:
          constraint.mixRotate = data.mixRotate;
          constraint.mixX = data.mixX;
          constraint.mixY = data.mixY;
          constraint.mixScaleX = data.mixScaleX;
          constraint.mixScaleY = data.mixScaleY;
          constraint.mixShearY = data.mixShearY;
          return;

        case MixBlend.first:
          constraint.mixRotate += (data.mixRotate - constraint.mixRotate) * alpha;
          constraint.mixX += (data.mixX - constraint.mixX) * alpha;
          constraint.mixY += (data.mixY - constraint.mixY) * alpha;
          constraint.mixScaleX += (data.mixScaleX - constraint.mixScaleX) * alpha;
          constraint.mixScaleY += (data.mixScaleY - constraint.mixScaleY) * alpha;
          constraint.mixShearY += (data.mixShearY - constraint.mixShearY) * alpha;
      }

      return;
    }

    var rotate, x, y, scaleX, scaleY, shearY;
    var i = Timeline.search(frames, time, 7
    /*ENTRIES*/
    );
    var curveType = this.curves[i / 7
    /*ENTRIES*/
    ];

    switch (curveType) {
      case 0
      /*LINEAR*/
      :
        var before = frames[i];
        rotate = frames[i + 1
        /*ROTATE*/
        ];
        x = frames[i + 2
        /*X*/
        ];
        y = frames[i + 3
        /*Y*/
        ];
        scaleX = frames[i + 4
        /*SCALEX*/
        ];
        scaleY = frames[i + 5
        /*SCALEY*/
        ];
        shearY = frames[i + 6
        /*SHEARY*/
        ];
        var t = (time - before) / (frames[i + 7
        /*ENTRIES*/
        ] - before);
        rotate += (frames[i + 7
        /*ENTRIES*/
        + 1
        /*ROTATE*/
        ] - rotate) * t;
        x += (frames[i + 7
        /*ENTRIES*/
        + 2
        /*X*/
        ] - x) * t;
        y += (frames[i + 7
        /*ENTRIES*/
        + 3
        /*Y*/
        ] - y) * t;
        scaleX += (frames[i + 7
        /*ENTRIES*/
        + 4
        /*SCALEX*/
        ] - scaleX) * t;
        scaleY += (frames[i + 7
        /*ENTRIES*/
        + 5
        /*SCALEY*/
        ] - scaleY) * t;
        shearY += (frames[i + 7
        /*ENTRIES*/
        + 6
        /*SHEARY*/
        ] - shearY) * t;
        break;

      case 1
      /*STEPPED*/
      :
        rotate = frames[i + 1
        /*ROTATE*/
        ];
        x = frames[i + 2
        /*X*/
        ];
        y = frames[i + 3
        /*Y*/
        ];
        scaleX = frames[i + 4
        /*SCALEX*/
        ];
        scaleY = frames[i + 5
        /*SCALEY*/
        ];
        shearY = frames[i + 6
        /*SHEARY*/
        ];
        break;

      default:
        rotate = this.getBezierValue(time, i, 1
        /*ROTATE*/
        , curveType - 2
        /*BEZIER*/
        );
        x = this.getBezierValue(time, i, 2
        /*X*/
        , curveType + 18
        /*BEZIER_SIZE*/
        - 2
        /*BEZIER*/
        );
        y = this.getBezierValue(time, i, 3
        /*Y*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 2 - 2
        /*BEZIER*/
        );
        scaleX = this.getBezierValue(time, i, 4
        /*SCALEX*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 3 - 2
        /*BEZIER*/
        );
        scaleY = this.getBezierValue(time, i, 5
        /*SCALEY*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 4 - 2
        /*BEZIER*/
        );
        shearY = this.getBezierValue(time, i, 6
        /*SHEARY*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 5 - 2
        /*BEZIER*/
        );
    }

    if (blend == MixBlend.setup) {
      var _data = constraint.data;
      constraint.mixRotate = _data.mixRotate + (rotate - _data.mixRotate) * alpha;
      constraint.mixX = _data.mixX + (x - _data.mixX) * alpha;
      constraint.mixY = _data.mixY + (y - _data.mixY) * alpha;
      constraint.mixScaleX = _data.mixScaleX + (scaleX - _data.mixScaleX) * alpha;
      constraint.mixScaleY = _data.mixScaleY + (scaleY - _data.mixScaleY) * alpha;
      constraint.mixShearY = _data.mixShearY + (shearY - _data.mixShearY) * alpha;
    } else {
      constraint.mixRotate += (rotate - constraint.mixRotate) * alpha;
      constraint.mixX += (x - constraint.mixX) * alpha;
      constraint.mixY += (y - constraint.mixY) * alpha;
      constraint.mixScaleX += (scaleX - constraint.mixScaleX) * alpha;
      constraint.mixScaleY += (scaleY - constraint.mixScaleY) * alpha;
      constraint.mixShearY += (shearY - constraint.mixShearY) * alpha;
    }
  };

  return TransformConstraintTimeline;
}(CurveTimeline);
/** Changes a path constraint's {@link PathConstraint#position}. */


exports.TransformConstraintTimeline = TransformConstraintTimeline;

var PathConstraintPositionTimeline = /*#__PURE__*/function (_CurveTimeline21) {
  _inheritsLoose(PathConstraintPositionTimeline, _CurveTimeline21);

  function PathConstraintPositionTimeline(frameCount, bezierCount, pathConstraintIndex) {
    var _this23;

    _this23 = _CurveTimeline21.call(this, frameCount, bezierCount, Property.pathConstraintPosition + "|" + pathConstraintIndex) || this;
    /** The index of the path constraint slot in {@link Skeleton#pathConstraints} that will be changed. */

    _this23.pathConstraintIndex = 0;
    _this23.pathConstraintIndex = pathConstraintIndex;
    return _this23;
  }

  var _proto27 = PathConstraintPositionTimeline.prototype;

  _proto27.apply = function apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
    var constraint = skeleton.pathConstraints[this.pathConstraintIndex];
    if (!constraint.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      switch (blend) {
        case MixBlend.setup:
          constraint.position = constraint.data.position;
          return;

        case MixBlend.first:
          constraint.position += (constraint.data.position - constraint.position) * alpha;
      }

      return;
    }

    var position = this.getCurveValue(time);
    if (blend == MixBlend.setup) constraint.position = constraint.data.position + (position - constraint.data.position) * alpha;else constraint.position += (position - constraint.position) * alpha;
  };

  return PathConstraintPositionTimeline;
}(CurveTimeline1);
/** Changes a path constraint's {@link PathConstraint#spacing}. */


exports.PathConstraintPositionTimeline = PathConstraintPositionTimeline;

var PathConstraintSpacingTimeline = /*#__PURE__*/function (_CurveTimeline22) {
  _inheritsLoose(PathConstraintSpacingTimeline, _CurveTimeline22);

  function PathConstraintSpacingTimeline(frameCount, bezierCount, pathConstraintIndex) {
    var _this24;

    _this24 = _CurveTimeline22.call(this, frameCount, bezierCount, Property.pathConstraintSpacing + "|" + pathConstraintIndex) || this;
    /** The index of the path constraint slot in {@link Skeleton#getPathConstraints()} that will be changed. */

    _this24.pathConstraintIndex = 0;
    _this24.pathConstraintIndex = pathConstraintIndex;
    return _this24;
  }

  var _proto28 = PathConstraintSpacingTimeline.prototype;

  _proto28.apply = function apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
    var constraint = skeleton.pathConstraints[this.pathConstraintIndex];
    if (!constraint.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      switch (blend) {
        case MixBlend.setup:
          constraint.spacing = constraint.data.spacing;
          return;

        case MixBlend.first:
          constraint.spacing += (constraint.data.spacing - constraint.spacing) * alpha;
      }

      return;
    }

    var spacing = this.getCurveValue(time);
    if (blend == MixBlend.setup) constraint.spacing = constraint.data.spacing + (spacing - constraint.data.spacing) * alpha;else constraint.spacing += (spacing - constraint.spacing) * alpha;
  };

  return PathConstraintSpacingTimeline;
}(CurveTimeline1);
/** Changes a transform constraint's {@link PathConstraint#getMixRotate()}, {@link PathConstraint#getMixX()}, and
 * {@link PathConstraint#getMixY()}. */


exports.PathConstraintSpacingTimeline = PathConstraintSpacingTimeline;

var PathConstraintMixTimeline = /*#__PURE__*/function (_CurveTimeline23) {
  _inheritsLoose(PathConstraintMixTimeline, _CurveTimeline23);

  function PathConstraintMixTimeline(frameCount, bezierCount, pathConstraintIndex) {
    var _this25;

    _this25 = _CurveTimeline23.call(this, frameCount, bezierCount, [Property.pathConstraintMix + "|" + pathConstraintIndex]) || this;
    /** The index of the path constraint slot in {@link Skeleton#getPathConstraints()} that will be changed. */

    _this25.pathConstraintIndex = 0;
    _this25.pathConstraintIndex = pathConstraintIndex;
    return _this25;
  }

  var _proto29 = PathConstraintMixTimeline.prototype;

  _proto29.getFrameEntries = function getFrameEntries() {
    return 4
    /*ENTRIES*/
    ;
  };

  _proto29.setFrame = function setFrame(frame, time, mixRotate, mixX, mixY) {
    var frames = this.frames;
    frame <<= 2;
    frames[frame] = time;
    frames[frame + 1
    /*ROTATE*/
    ] = mixRotate;
    frames[frame + 2
    /*X*/
    ] = mixX;
    frames[frame + 3
    /*Y*/
    ] = mixY;
  };

  _proto29.apply = function apply(skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
    var constraint = skeleton.pathConstraints[this.pathConstraintIndex];
    if (!constraint.active) return;
    var frames = this.frames;

    if (time < frames[0]) {
      switch (blend) {
        case MixBlend.setup:
          constraint.mixRotate = constraint.data.mixRotate;
          constraint.mixX = constraint.data.mixX;
          constraint.mixY = constraint.data.mixY;
          return;

        case MixBlend.first:
          constraint.mixRotate += (constraint.data.mixRotate - constraint.mixRotate) * alpha;
          constraint.mixX += (constraint.data.mixX - constraint.mixX) * alpha;
          constraint.mixY += (constraint.data.mixY - constraint.mixY) * alpha;
      }

      return;
    }

    var rotate, x, y;
    var i = Timeline.search(frames, time, 4
    /*ENTRIES*/
    );
    var curveType = this.curves[i >> 2];

    switch (curveType) {
      case 0
      /*LINEAR*/
      :
        var before = frames[i];
        rotate = frames[i + 1
        /*ROTATE*/
        ];
        x = frames[i + 2
        /*X*/
        ];
        y = frames[i + 3
        /*Y*/
        ];
        var t = (time - before) / (frames[i + 4
        /*ENTRIES*/
        ] - before);
        rotate += (frames[i + 4
        /*ENTRIES*/
        + 1
        /*ROTATE*/
        ] - rotate) * t;
        x += (frames[i + 4
        /*ENTRIES*/
        + 2
        /*X*/
        ] - x) * t;
        y += (frames[i + 4
        /*ENTRIES*/
        + 3
        /*Y*/
        ] - y) * t;
        break;

      case 1
      /*STEPPED*/
      :
        rotate = frames[i + 1
        /*ROTATE*/
        ];
        x = frames[i + 2
        /*X*/
        ];
        y = frames[i + 3
        /*Y*/
        ];
        break;

      default:
        rotate = this.getBezierValue(time, i, 1
        /*ROTATE*/
        , curveType - 2
        /*BEZIER*/
        );
        x = this.getBezierValue(time, i, 2
        /*X*/
        , curveType + 18
        /*BEZIER_SIZE*/
        - 2
        /*BEZIER*/
        );
        y = this.getBezierValue(time, i, 3
        /*Y*/
        , curveType + 18
        /*BEZIER_SIZE*/
        * 2 - 2
        /*BEZIER*/
        );
    }

    if (blend == MixBlend.setup) {
      var data = constraint.data;
      constraint.mixRotate = data.mixRotate + (rotate - data.mixRotate) * alpha;
      constraint.mixX = data.mixX + (x - data.mixX) * alpha;
      constraint.mixY = data.mixY + (y - data.mixY) * alpha;
    } else {
      constraint.mixRotate += (rotate - constraint.mixRotate) * alpha;
      constraint.mixX += (x - constraint.mixX) * alpha;
      constraint.mixY += (y - constraint.mixY) * alpha;
    }
  };

  return PathConstraintMixTimeline;
}(CurveTimeline);

exports.PathConstraintMixTimeline = PathConstraintMixTimeline;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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